import { EmptyState } from '@/components/common/feedback';
import { hasInAppHistory, useGoBack } from '@/lib/navigation';

export const NotFoundPage = () => {
  const goBack = useGoBack('/');
  return (
    <EmptyState
      title="お探しの画面が見つかりません"
      description="URL が変わったか、権限がない可能性があります"
      action={{ label: hasInAppHistory() ? '前の画面に戻る' : 'ホームへ戻る', onClick: goBack }}
    />
  );
};
